import classNames from "classnames/bind";
import styles from './Footer.module.scss';

const cx = classNames.bind(styles);

type FormInputProps = {
    name: string;
    type?: string;
    placeholder: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    width?: "full" | "half" | "quarter";
  };

export default function FormInput ({ name, type, placeholder, value, onChange, width }: FormInputProps) {
    return(
    <div className={cx("input-wrapper", width)}>
        <label className={cx("tag-s", "form-eyebrow", { "show": !!value })} >
            {placeholder}
        </label>
        <input
            className={cx("input", "text-m", { "filled": !!value })}
            type={ type ?? 'text' }
            name={name}
            required
            onChange={onChange}
            placeholder={placeholder}
            value={value}
        />
    </div>
    );
};